module.exports = __webpack_public_path__ + "static/cafe-52ed5f591cbc802310d791237d0eb41f.gif";